"use client";
import { Section } from "@/components/ui/section";
import { useTranslation } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { siteConfig } from "@/config/site";
import Glow from "@/components/ui/glow";

export default function CTA() {
  const { t } = useTranslation("common");
  return (
    <Section className="group relative overflow-hidden">
      <div className="relative z-10 mx-auto flex max-w-container flex-col items-center gap-6 text-center sm:gap-8">
        <h2 className="text-3xl font-semibold sm:text-5xl">
          {t("cta.title")}
        </h2>
        <p className="text-md max-w-[560px] font-medium text-muted-foreground sm:text-xl">
          {t("cta.subtitle")}
        </p>
        <div className="flex gap-4">
          <Button variant="default" size="lg" asChild>
            <a href={siteConfig.bookDemoUrl}>{t("cta.book_demo")}</a>
          </Button>
          <Button variant="glow" size="lg" asChild>
            <a href={siteConfig.signUp}>{t("cta.sign_in")}</a>
          </Button>
        </div>
      </div>
      <div className="absolute left-0 top-0 h-full w-full translate-y-[1rem] opacity-80 transition-all duration-500 ease-in-out group-hover:translate-y-[-2rem] group-hover:opacity-100">
        <Glow variant="bottom" />
      </div>
    </Section>
  );
}
